import React, { memo } from "react";
import { Avatar, AvatarProps, Dropdown, MenuProps, Space, Button } from "antd";
import {
  UserOutlined,
  DownOutlined,
  LogoutOutlined,
  LockOutlined,
} from "@ant-design/icons";
import {
  COLORS,
  i18n,
  logOut,
  routesName,
  storeToken,
  useGetUserGetUserProfile,
  // useGetProfileCurrentUser,
  // usePostAuthLogout,
} from "core";
import { createUseStyles } from "react-jss";
import LoadingView from "../../atoms/loadingView";
import { useNavigate } from "react-router-dom";

const useStyle = createUseStyles<string, unknown, COLORS>((colors) => ({
  profileBtn: {
    color: colors.theme01,
    border: `1.2px solid ${colors.theme01}`,
    fontWeight: "bold",
    height: "40px",
    marginLeft: "20px",
    backgroundColor: colors.black,
  },
  profileIcon: {
    color: colors.theme01,
  },
  avatar: {
    marginLeft: "5px",
    backgroundColor: colors.black,
  },
}));

interface Props extends AvatarProps {
  src?: any;
  profileClick?: () => void;
  changePasswordClick?: () => void;
}

const ProfileButton = memo<Props>(
  ({
    // src,
    // profileClick,
    changePasswordClick,
  }) => {
    const { data: { data } = {}, isFetching } =
    useGetUserGetUserProfile({ refetchOnWindowFocus: false });
    
    // const navigate = useNavigate();

    // const { mutate } = use({
    //   onSuccess: () => {
    //     navigate(routesName.LOGIN);
    //   },
    // });

    const classes = useStyle();
    const items: MenuProps["items"] = [
      // {
      //   label: i18n.t("profile"),
      //   key: "1",
      //   icon: <UserOutlined />,
      // },
      {
        label: i18n.t("changePassword"),
        key: "2",
        icon: <LockOutlined />,
      },
      {
        label: i18n.t("exit"),
        key: "3",
        icon: <LogoutOutlined />,
      },
    ];
    const dispatch = storeToken.useDispatch();
    const handleMenuClick: MenuProps["onClick"] = (e) => {
      // if (e.key === '1' && profileClick) {
      //   profileClick();
      // } else
      if (e.key === "2" && changePasswordClick) {
        changePasswordClick();
      } else if (e.key === "3") {
        dispatch(logOut())
      }
    };

    const menuProps = {
      items,
      onClick: handleMenuClick,
    };
    return (
      <>
        {/* <LoadingView isLoading={isFetching}> */}
        <Dropdown menu={menuProps}>
          <Button className={classes.profileBtn}>
            <Avatar
              className={classes.avatar}
              // src={src}
              icon={<UserOutlined className={classes.profileIcon} />}
            />
            <Space>
              {data?.nameAndFamily || i18n.t('userName')}
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>
        {/* </LoadingView> */}
      </>
    );
  }
);

export { ProfileButton };
